<template>
  <section class="payment_sec h-100" v-show="paymentId == ''">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-lg-4 m-auto">
          <div class="payment_box">
            <a class="logonew" href="javascript:;"><img :src="`${publicPath}images/logo.svg`"></a>
            <div class="successpay">
              <img :src="`${publicPath}images/nothing-found.png`"  style="width: 300px; height: 220px;">
            </div>
           <div class="row justify-content-center"><p><strong>Sorry Nothing Found</strong></p></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="payment_sec page-blockui" v-show="paymentId != ''">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-lg-6 m-auto">
          <div class="payment_box">
            <Form @submit="sendCall" ref="myForm">
              <div class="payment_box_inn">
                <a class="logonew" href="#"><img :src="`${publicPath}images/logo.svg`"></a>
                <div class="toptransition">
                  <div class="toptransitiontext">
                    <p class="merchant_name">{{name}}</p>
                    <small class="tranx_id" style="color: #4DC44A">#{{ firstPaymentId }}</small>
                  </div>
                  <img width="65px" style="width: 65px" class="pl-1" :src="avatar">
                </div>
                <div v-if="otherInfoReceiptNo != ''" class="toptransition mr-5">
                  <div class="toptransitiontext">
                    <p class="merchant_name">ReceiptNo</p>
                    <p class="tranx_id">{{otherInfoReceiptNo}}</p>
                  </div>

                </div>
                <h2>Payment Details</h2>
                <div class="form-group mt-4">
                  <label>Name</label>
                  <Field type="text" name="name" class="form-control" placeholder="John Miller"
                         rules="required|alpha_spaces"/>
                  <ErrorMessage as="small" class="text-danger" name="name"/>
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <Field type="text" name="email" class="form-control" placeholder="miller@vaultspay.ae"
                         rules="required|email"/>
                  <ErrorMessage as="small" class="text-danger" name="email"/>
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <Field type="tel" name="phone" class="form-control" placeholder="Enter Phone Number"
                         rules="required|phone"/>
                  <ErrorMessage as="small" class="text-danger" name="phone"/>
                </div>
                <div class="form-group">
                  <label>Card Holder Name</label>
                  <Field type="text" name="cardHolderName" class="form-control" placeholder="John Miller"
                         rules="required|alpha_spaces"/>
                  <ErrorMessage as="small" class="text-danger" name="cardHolderName"/>
                  <p class="log text-success"></p>
                </div>
                <div class="form-group">
                  <label>Card Holder Number</label>
<!--                  <Field type="tel" name="cardNumber" class="form-control cardnumber creditCardText" placeholder="0000-0000-0000-0000"-->
<!--                         rules="required|card|cardMaxLength:20"/>-->
<!--                  <ErrorMessage as="small" class="text-danger" name="cardNumber"/>-->
<!--                  <p class="log text-success"></p>-->
                  <cleave v-model="cardNumber"
                          :options="options"
                          placeholder="0000-0000-0000-0000"
                          class="form-control cardnumber"
                          name="card"/>
                  <small class="text-danger"  v-show="cardError">The field is required</small>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-lg-4">
                    <div class="form-group">
                      <label>Expiry Month</label>
                      <Field type="text" name="expMonth" as="select" class="form-control gryColor"
                             rules="required" @change="(e)=> selectedMonth = e.target.value">
                        <option value="" disabled >Month</option>
                        <option :value="mon" v-for="mon in monthList">{{mon}}</option>
                      </Field>
                      <ErrorMessage as="small" class="text-danger" name="expMonth"/>

                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-4">
                    <div class="form-group">
                      <label>Expiry Year</label>
                      <Field type="text" name="expYear" as="select" class="form-control gryColor"
                             rules="required" @change="yearChanged">
                        <option value="" disabled selected >Year</option>
                        <option :value="year.toString().substr(-2)" v-for="(year,index) in yearList">{{year}}</option>
                      </Field>
                      <ErrorMessage as="small" class="text-danger" name="expYear"/>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-4">
                    <div class="form-group">
                      <label>CVV</label>
                      <Field type="password" name="cvc" class="form-control" placeholder="✪✪✪"
                             rules="required|numeric|min:3|max:4"/>
                      <ErrorMessage as="small" class="text-danger" name="cvc"/>
                    </div>
                  </div>
                </div>
                <template v-if="requiredAddress">
                  <div class="row">
                    <div class="col-sm-12 col-lg-12">
                      <div class="form-group mb-half-rem">
                        <label>Country</label>
                        <Field type="text" name="country" as="select" class="form-control gryColor"
                               rules="required" @change="(e)=> selectedCountry = e.target.value">
                          <option value="" disabled selected >Country</option>
                          <option :value="JSON.stringify(country)" :key="country.id" v-for="country in countries">{{country.name}}</option>
                        </Field>
                        <ErrorMessage as="small" class="text-danger" name="country"/>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-lg-6">
                      <div class="form-group mb-half-rem">
                        <label>State</label>
                        <Field type="text" name="state"  as="select" class="form-control gryColor"
                               rules="required" @change="(e)=> selectedState = e.target.value">
                          <option value="" disabled selected >State</option>
                          <option :value="JSON.stringify(state)" :key="state.id" v-for="state in states">{{state.name}}</option>
                        </Field>
                        <ErrorMessage as="small" class="text-danger" name="state"/>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="form-group mb-half-rem">
                        <label>City</label>
                        <Field type="text" name="city" as="select" class="form-control gryColor"
                               rules="required" @change="(e)=> selectedCity = e.target.value">
                          <option value="" disabled selected >City</option>
                          <option :value="JSON.stringify(city)" :key="city.id" v-for="city in cities">{{city.name}}</option>
                        </Field>
                        <ErrorMessage as="small" class="text-danger" name="city"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-lg-12">
                      <div class="form-group mb-half-rem">
                        <label>Address</label>
                        <Field rules="required|min:10|max:150" type="text" name="address" class="form-control" placeholder="Address"
                        />
                        <ErrorMessage as="small" class="text-danger" name="address"/>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="ammountsec text-center">
                <button class="nextbtn paynowbtn btn btn-page-block-custom">Pay Now: {{currency+' '+amount/100}}</button>
              </div>
            </Form>
            <div class="cardview" >
              <img style="width: 60% !important;"  :src="`${publicPath}images/mastervisa1.png`">
            </div>
            <hr class="linehr">
            <div class="tearm_sec mt-0 pl-3 pr-3 pb-0">
              <img width="80px" style="width: 80px" :src="`${publicPath}images/sectigo_trust_seal.png`">
              <img  width="80px" style="width: 80px" :src="`${publicPath}images/mastervisa2.png`">
              <img width="60px" style="width: 60px" :src="`${publicPath}images/logo.svg`">
            </div>
            <div class="pb-1 m-auto">
              <p class="text-center"><small>You agree to <a target="_blank" href="https://vaultspay.com/terms-and-condition">Our Terms</a> and <a target="_blank" href="https://vaultspay.com/privacy-policy">Privacy
                Policy</a></small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    <div v-show="loader" class="blockUI" style="display:none"></div>
    <div v-show="loader" class="blockUI blockOverlay"
         style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
    <div v-show="loader" class="blockUI blockMsg blockPage"
         style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
      <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait you request is being processed...</p>
        <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
      </div>
    </div>
</template>

<script>
import Cleave from 'vue-cleave-component';
import reCaptchaMixin from '@/mixins/reCaptchaMixin';

export default {
  mixins: [reCaptchaMixin],
  components: {
    Cleave
  },
  computed: {
  },
  async mounted() {
    // window.cardInit()
    this.tempMonthList = this.monthList
    if(typeof(localStorage.getItem('firstPaymentId')) != 'undefined'){
      this.firstPaymentId = localStorage.getItem('firstPaymentId')
    }
    this.generateYears()
    if(typeof(localStorage.getItem('checkPaymentData')) != 'undefined'){
      if(JSON.parse(localStorage.getItem('checkPaymentData'))){
        let data = JSON.parse(localStorage.getItem('checkPaymentData'))
        this.name = data.details.name
        this.avatar = data.details.avatar
        this.amount = data.details.amount
        this.currency = data.details.currency
        if(data?.methods && data.methods.length > 0){
          let selectedMethodType = localStorage.getItem('selectedMethodType')
          Object.keys(data.methods).map((key)=>{
            if(data.methods[key].type == selectedMethodType ){
              if(data.methods[key]?.addressRequired){
                this.requiredAddress = true
              }
            }
          })
        }
        if(this.requiredAddress){
          await this.loadCountries();
          this.loadStates()
          this.loadCities()
        }
        if(data.details.otherInfo){
          if(typeof(data.details.otherInfo.email)!= 'undefined'){
            this.$refs.myForm.setFieldValue('email',data.details.otherInfo.email);
          }
          if(typeof(data.details.otherInfo.phone)!= 'undefined'){
            this.$refs.myForm.setFieldValue('phone',data.details.otherInfo.phone);
          }
          if(typeof(data.details.otherInfo.receiptNo)!= 'undefined'){
            this.otherInfoReceiptNo = data.details.otherInfo.receiptNo
          }
        }
      }
    }



    this.paymentId = typeof (this.$route.query.paymentId) != 'undefined' ? this.$route.query.paymentId : ''
  },
  data() {
    return {
      requiredAddress:false,
      countries: [],
      selectedCountry: "",
      states: [],
      allStates:[],
      allCities:[],
      cities: [],
      selectedState: "",
      selectedCity:"",
      cardNumber: '',
      cardError: true,
      options: {
        creditCard: true,
        delimiter: '-',
      },
      paymentId: '',
      firstPaymentId: '',
      loader:false,
      name:'',
      avatar:'',
      amount : '',
      currency : '',
      otherInfoEmail:'',
      otherInfoPhone:'',
      otherInfoReceiptNo:'',
      yearList:[],
      selectedMonth:'',
      monthList:[
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      tempMonthList:[]
    }
  },
  methods: {
    async loadCountries() {
      const response = await fetch('/assets/countries.json');
      this.countries = await response.json();
    },
    async loadStates() {
      const response = await fetch('/assets/states.json');
      this.allStates = await response.json();
    },
    async loadCities() {
      const response = await fetch('/assets/cities.json');
      this.allCities = await response.json();
    },
    yearChanged(e){
      var time = new Date();
      //     var x = new Date();
      // x.setDate(1);
      // x.setMonth(x.getMonth()-3);
      // time= x
      var currentYear = time.getYear().toString().substr(-2);
      var currentMonth = ("0" + (time.getMonth() + 1)).slice(-2);
      this.monthList = this.tempMonthList
      if(currentYear == e.target.value ){
        this.monthList = this.monthList.filter((item,index) =>{
          return item>=currentMonth
        })
        if(currentMonth>this.selectedMonth){
          this.$refs.myForm.setFieldValue('expMonth',"");
        }

      }
    },
    redirect(url) {
      window.location.replace(url)
      // setTimeout(() => {window.history.forward()},0)
      // window.onunload = function () { null };
      // this.$router.replace({path: url})
      return
      // var win = window.open(url,'_blank');
      // var win = window.open(url,"_self");
      // win.focus();
      // window.open(url,
      //     'newwindow',
      //     'width=300,height=250');

    },
    async sendCall(values) {
      // this.$router.replace({name:'payment-success',query: { txnId: 'sada' }})

      if(this.cardError){
        return
      }

      let data = values
      data.cardNumber = this.cardNumber
      data.referenceId = this.paymentId

      if(this.requiredAddress){
        data.country = JSON.parse(this.selectedCountry)?.country_code
        data.state = JSON.parse(this.selectedState)?.name
        data.city = JSON.parse(this.selectedCity)?.name
      }

      if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
        try {
          const token = await this.executeRecaptcha('submit');
          this.recaptchaToken = token;

        } catch (error) {
          console.error('reCAPTCHA error:', error);
        }

        data = {
          ...data,
          verResponse: this.recaptchaToken,
          resId: Date.now()
        }
      }

      this.loader = true
      this.makeRequest('post', 'v1/process-payment-link', data,{},false).then(callResponse => {
        // this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data.bypass3DS){
              // if(typeof(data.callback_url) != 'undefined'){
              //   localStorage.setItem('transaction-callbackUrl',data.callback_url);
              // }else{
              //   localStorage.setItem('transaction-callbackUrl',data.callback_url);
              // }
              localStorage.setItem('transaction-payment-details',JSON.stringify(data));
              this.$router.replace({name:'payment-success',query: { txnId: data.transactionId }})
            }else{
              this.redirect(data.paymentUrl)
            }

          }else{
            localStorage.setItem('errorMessage',callResponse.response.data.message);
            this.$router.push({name:'payment-failed'})
          }
        }

      });
    },
    generateYears(){

      var time = new Date();
      // var year = time.getYear().toString().substr(-2);
      var year = time.getFullYear();
      var date = parseInt(year)
      var future = parseInt(year) + 20; /*change the '20' to the number of years in the future you want to show */
      do {
        this.yearList.push(date)
        date++;
      }
      while (date < future)

    },
    getStatesByCountry(countryId) {
      return this.allStates.filter(state => state.countryId == countryId);
    },
    getCitiesByState(stateId) {
      return this.allCities.filter(city => city.stateId == stateId);
    }
  },
  watch:{
    selectedCountry(newCountry) {
      this.selectedState = "";
      this.selectedCity = ""
      this.cities = [];
      this.states = []
      if(newCountry){
        this.states = this.getStatesByCountry(JSON.parse(newCountry)?.id);
      }
    },
    selectedState(newState) {
      this.selectedCity = ""
      this.cities = [];
      if(newState){
        this.cities = this.getCitiesByState(JSON.parse(newState)?.id);
      }
    },
    cardNumber(val){
      if(val.length == ''){
        this.cardError = true
      }else{
        this.cardError = false
      }
    }
  }
}
</script>

<style scoped>
  .gryColor{
    color: gray !important;
  }
</style>


